// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'fb5acb2e-b829-401a-b42a-37ac33830a65',
      type: 'NineSlicePlane',
      name: 'beigeBackground',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 406,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: false
        }
      }
    },
    {
      id: '81b24c3d-79f7-4bf8-bc02-37784b923ddf',
      type: 'NineSlicePlane',
      name: 'beigeBackgroundLarge',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 441,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: true
        }
      }
    },
    {
      id: '947b3e1a-e497-4dcc-9607-a63b4cbaa948',
      type: 'NineSlicePlane',
      name: 'beigeBackgroundNoTitle',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 441,
      leftWidth: 48,
      topHeight: 48,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_9Slice_48x48x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'a2fe623a-c455-4152-a948-52f261271996',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        rotationCycle: 40000
      },
      stateByName: {
        watchAd: {
          scale: {
            x: 1.5,
            y: 1.5
          },
          y: 26
        }
      }
    },
    {
      id: 'b13d4892-45f5-478b-9ed6-a15559bc928b',
      type: 'Text',
      name: 'textDescription',
      className: '',
      x: 0,
      y: -164,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Try Again?',
      localize: true,
      maxWidth: 600,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8f2c2b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          y: -164
        }
      }
    },
    {
      id: 'e1d98404-7dc8-49ab-ad06-4f4728251894',
      type: 'Container',
      name: 'scaleContainer',
      className: '',
      x: 0,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          scale: {
            x: 1.1,
            y: 1.1
          },
          y: 83
        }
      }
    },
    {
      id: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e',
      type: 'Container',
      name: 'heartContainer',
      className: '',
      x: 0,
      y: -28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: 'a3257911-b73f-4de3-b1ee-502cea98d8d4',
      type: 'Container',
      name: 'brokenHeartContainer',
      className: '',
      x: 0,
      y: -28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: 'e251b416-5ca5-465c-80c5-cb6b06c15867',
      type: 'Sprite',
      name: 'heartPiece1',
      className: '',
      x: 25,
      y: 33,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Piece',
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: '99f6652f-6e33-492d-9e20-7db8e76a2fd2',
      type: 'Sprite',
      name: 'heartPiece2',
      className: '',
      x: -10,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Piece',
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: '08628d85-89cc-458a-8a9e-65fd758a9afd',
      type: 'Sprite',
      name: 'heartPiece3',
      className: '',
      x: -19,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Piece',
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: 'a86abdc3-e466-48f8-91cd-a2b7e5d35201',
      type: 'Sprite',
      name: 'heartPiece4',
      className: '',
      x: NaN,
      y: NaN,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: NaN,
        y: NaN
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Piece',
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: '918d38c3-8965-42c2-bc83-e1f7056aa070',
      type: 'Sprite',
      name: 'heartPiece5',
      className: '',
      x: -4,
      y: -113,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Piece',
      parent: 'e1d98404-7dc8-49ab-ad06-4f4728251894'
    },
    {
      id: '3fdeadf2-37c6-46cc-90dd-678063b51ebb',
      type: 'Sprite',
      name: 'heartShadow',
      className: '',
      x: 0,
      y: 8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 14332799,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New_White',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: 'd637888c-7603-4587-ad88-9a9a37ce08bc',
      type: 'Sprite',
      name: 'heart',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '9e141557-72d3-49c8-88fe-b9c7930f5a7a',
      type: 'Sprite',
      name: 'heartWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New_White',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '10b9dc1e-1043-4649-98d8-462f529b1741',
      type: 'Sprite',
      name: 'heartDark',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 10039353,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New_White',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '7e2e3d7a-6479-48d4-a515-4967b2046fb7',
      type: 'Sprite',
      name: 'infinity',
      className: '',
      x: 0,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Infinity',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: 'fe90e195-201b-429d-b789-9d58cbca6290',
      type: 'Text',
      name: 'currentLivesText',
      className: '',
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '5',
      localize: false,
      maxWidth: 180,
      maxHeight: 150,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 122,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#730027',
        strokeThickness: 10,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '086f758d-729e-43ea-82f1-816ae29ea583',
      type: 'Text',
      name: 'finalLivesText',
      className: '',
      x: 0,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '4',
      localize: false,
      maxWidth: 180,
      maxHeight: 150,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 122,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#730027',
        strokeThickness: 10,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '1217d282-7136-4c78-9a82-374ac18884da',
      type: 'Sprite',
      name: 'heartLeft1',
      className: '',
      x: 6,
      y: 113,
      anchor: {
        x: 0.8,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Left_Side',
      parent: 'a3257911-b73f-4de3-b1ee-502cea98d8d4'
    },
    {
      id: '15d764ff-fcb9-49cb-9002-db4ea4763e08',
      type: 'Sprite',
      name: 'heartRight1',
      className: '',
      x: -6,
      y: 112,
      anchor: {
        x: 0.2,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Right_Side',
      parent: 'a3257911-b73f-4de3-b1ee-502cea98d8d4'
    },
    {
      id: '087b228d-c6ca-43f8-abee-fc030b7a61f2',
      type: 'Sprite',
      name: 'crack',
      className: '',
      x: -5,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crack',
      parent: 'a3257911-b73f-4de3-b1ee-502cea98d8d4'
    },
    {
      id: '6dc2c306-d6f5-472d-b2c2-c1239d50fe9b',
      type: 'Sprite',
      name: 'heartLeftCrack',
      className: '',
      x: -55,
      y: -121,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Left_Side_Crack',
      parent: '1217d282-7136-4c78-9a82-374ac18884da'
    },
    {
      id: '33a1a32b-68ba-4a65-bacc-e56ce8821744',
      type: 'Sprite',
      name: 'heartRightCrack',
      className: '',
      x: 56,
      y: -136,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Right_Side_Crack',
      parent: '15d764ff-fcb9-49cb-9002-db4ea4763e08'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'watchAd'
  ],
  animations: [
    {
      id: '93d15cd5-2d40-4c06-a5d1-e7842927345d',
      name: 'Lose_Life',
      playingSpeed: 1,
      totalDuration: 1800,
      blocks: [
        {
          id: '2a93f746-8858-4fe1-bdf6-bc50b4571d99',
          type: 'Setter',
          name: 'brokenHeartAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'e104a12c-a63a-4c31-a608-4a877d651d9b',
          type: 'Setter',
          name: 'heartDarkAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'heartDark',
          disabled: false
        },
        {
          id: 'cbce67fa-351c-49fb-9969-baa501fbb56e',
          type: 'Setter',
          name: 'New_setter',
          track: 13,
          target: {
            y: -240
          },
          startAt: 0,
          sourceName: 'm',
          disabled: false
        },
        {
          id: 'a8f4e186-2179-4eca-8448-7a76f2358b1f',
          type: 'Setter',
          name: 'textAmount2Alpha',
          track: 47,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'finalLivesText',
          disabled: false
        },
        {
          id: '0abd2f10-dd9a-4f0c-8aaa-94e07bca22c1',
          type: 'Setter',
          name: 'heartAlpha_copy',
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'heartContainer',
          disabled: false
        },
        {
          id: 'd3a2c023-ceb8-483c-ad4b-31fffd1680d0',
          type: 'Setter',
          name: 'SFX_Soft_Fail',
          track: 49,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '16d804f9-84df-45bb-b241-ae3c5b7a23a5',
          type: 'Setter',
          name: 'textAmount2Alpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'finalLivesText',
          disabled: false
        },
        {
          id: 'f6ad3418-b9b1-4232-a80c-14dbe173477b',
          type: 'Setter',
          name: 'textAmount1Alpha',
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'currentLivesText',
          disabled: false
        },
        {
          id: '77010702-8fce-4aa2-8e6c-a13a238d7490',
          type: 'Tween',
          name: 'heartScale',
          duration: 100,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 0,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2419e627-ab7d-492d-b8ff-c6571a8b63cb',
          type: 'Tween',
          name: 'heartPosition',
          duration: 100,
          track: 6,
          target: {
            y: -17
          },
          startAt: 0,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '364bf063-1ebe-446a-8f33-0ffb902e0886',
          type: 'Tween',
          name: 'text1Scale',
          duration: 100,
          track: 4,
          target: {
            scale: {
              x: 1.08,
              y: 1.08
            }
          },
          startAt: 0,
          sourceName: 'currentLivesText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8da62d40-e43d-46c7-aa68-fa9808f0d028',
          type: 'Tween',
          name: 'text1Scale_copy',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 100,
          sourceName: 'currentLivesText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a0fa54b9-9441-4303-bbbc-1d78c0439958',
          type: 'Tween',
          name: 'heartScale_copy',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '97142204-f5a4-494d-a182-4f3da2d4b888',
          type: 'Tween',
          name: 'heartPosition_copy',
          duration: 300,
          track: 6,
          target: {
            y: -39
          },
          startAt: 100,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0c208843-ff66-4e32-b29e-7952d7b495e8',
          type: 'Tween',
          name: 'heartDarkAlpha_1',
          duration: 300,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'heartDark',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '26743527-a90a-4191-977b-50020acdc1ff',
          type: 'Setter',
          name: 'brokenHeartContainerAlpha',
          track: 9,
          target: {
            alpha: 1
          },
          startAt: 400,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'b4a7980e-ce7b-4028-9c39-0883a01527ab',
          type: 'Setter',
          name: 'crackAlpha_copy',
          track: 15,
          target: {
            alpha: 1
          },
          startAt: 400,
          sourceName: 'crack',
          disabled: false
        },
        {
          id: '19aefd3a-7a5f-4339-96b6-ef97512741cc',
          type: 'Setter',
          name: 'borkenHeartContainerPosition',
          track: 13,
          target: {
            y: -39
          },
          startAt: 400,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'f5bc1b97-bf5f-4e06-a1b3-eb837cf408ec',
          type: 'Setter',
          name: 'borkenHeartContainerScale',
          track: 11,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: '1e8b81cd-59b3-4991-837b-f2f5d9afe03a',
          type: 'Setter',
          name: 'heartAlpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 400,
          sourceName: 'heartContainer',
          disabled: false
        },
        {
          id: '96886092-99c4-446c-9d5e-a56b72948e89',
          type: 'Tween',
          name: 'heartPiece5Scale',
          duration: 100,
          track: 28,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'heartPiece5',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5d73ffe2-f75f-4013-9863-5e55a639919c',
          type: 'Tween',
          name: 'heartPiece5Rotation',
          duration: 300,
          track: 27,
          target: {
            angle: -80
          },
          startAt: 400,
          sourceName: 'heartPiece5',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '852b80de-fd05-46e7-8a49-e820aa64ec6e',
          type: 'Tween',
          name: 'heartPiecePosition',
          duration: 150,
          track: 26,
          target: {
            x: -51,
            y: -153
          },
          startAt: 400,
          sourceName: 'heartPiece5',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'ea0b2e7e-4599-43db-b3ef-7ee55484191b',
          type: 'Tween',
          name: 'heartLeftPosition',
          duration: 60,
          track: 17,
          target: {
            y: 93,
            x: -14
          },
          startAt: 400,
          sourceName: 'heartLeft1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '9a298481-1dd3-46e0-a9f2-5c1fbecb3927',
          type: 'Tween',
          name: 'heartRightPosition_1_1',
          duration: 60,
          track: 21,
          target: {
            x: 14,
            y: 93
          },
          startAt: 400,
          sourceName: 'heartRight1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'bd83075e-09a3-4074-812d-c58cbbec0639',
          type: 'Tween',
          name: 'heartPiece3Scale',
          duration: 100,
          track: 37,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 410,
          sourceName: 'heartPiece3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6e59e3d3-7d57-4fe2-aeb7-d130c2f5cc06',
          type: 'Tween',
          name: 'heartPiece3Rotation',
          duration: 300,
          track: 36,
          target: {
            angle: 50
          },
          startAt: 410,
          sourceName: 'heartPiece3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e0109d5b-7f88-44a0-ab8e-5680108b465a',
          type: 'Tween',
          name: 'heartPiece3Position',
          duration: 150,
          track: 35,
          target: {
            x: -63,
            y: -51
          },
          startAt: 410,
          sourceName: 'heartPiece3',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '844ae0c3-9747-4185-b08d-675d9eeab781',
          type: 'Tween',
          name: 'borkenHeartContainerPosition',
          duration: 140,
          track: 13,
          target: {
            y: -28
          },
          startAt: 410,
          sourceName: 'brokenHeartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ef7e0d65-b137-4dc6-bda0-da7518462f47',
          type: 'Tween',
          name: 'borkenHeartContainerScale',
          duration: 140,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 410,
          sourceName: 'brokenHeartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '35a7d85d-31cc-494d-9ab7-921f348e9968',
          type: 'Tween',
          name: 'heartPiece4Scale',
          duration: 100,
          track: 32,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 420,
          sourceName: 'heartPiece4',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2dce254a-1897-44ad-8ee9-27b663076e3e',
          type: 'Tween',
          name: 'heartPiece4Rotation',
          duration: 300,
          track: 31,
          target: {
            angle: 80
          },
          startAt: 420,
          sourceName: 'heartPiece4',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ca8bad96-ba2d-472a-82c4-44d717b3ffca',
          type: 'Tween',
          name: 'heartPiece4Position',
          duration: 100,
          track: 30,
          target: {
            x: 45,
            y: -98
          },
          startAt: 420,
          sourceName: 'heartPiece4',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '866da0ad-0fd7-41a3-a0f9-24757f304d69',
          type: 'Setter',
          name: 'crackAlpha',
          track: 15,
          target: {
            alpha: 0
          },
          startAt: 450,
          sourceName: 'crack',
          disabled: false
        },
        {
          id: 'f94f1ac4-d7a4-458d-8b8d-f110224a2fbd',
          type: 'Tween',
          name: 'heartPiece1Scale',
          duration: 100,
          track: 45,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 450,
          sourceName: 'heartPiece1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4b0016d4-3379-4d3f-b487-a9af1f62a2fc',
          type: 'Tween',
          name: 'heartPiece1Rotation',
          duration: 300,
          track: 44,
          target: {
            angle: -30
          },
          startAt: 450,
          sourceName: 'heartPiece1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '58a55518-62a4-4a2d-921f-4c88f8afeaf3',
          type: 'Tween',
          name: 'heartPiece1Position',
          duration: 150,
          track: 43,
          target: {
            x: 55,
            y: -23
          },
          startAt: 450,
          sourceName: 'heartPiece1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '7b12639f-f9d2-4124-a233-0a8f1ad07e7f',
          type: 'Tween',
          name: 'heartRightPosition_1_1_copy',
          duration: 60,
          track: 21,
          target: {
            x: 44,
            y: 103
          },
          startAt: 460,
          sourceName: 'heartRight1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '63d96f1f-c565-4a12-80d3-944a8f439824',
          type: 'Tween',
          name: 'heartLeftPosition_copy',
          duration: 60,
          track: 17,
          target: {
            y: 103,
            x: -44
          },
          startAt: 460,
          sourceName: 'heartLeft1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a08469c2-b839-41f2-bcbc-eb202a5fb85e',
          type: 'Tween',
          name: 'heartPiece2Scale',
          duration: 100,
          track: 41,
          target: {
            scale: {
              x: 0.7,
              y: 0.7
            }
          },
          startAt: 500,
          sourceName: 'heartPiece2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '65be5936-dcbf-41d5-924c-1fe339ff9708',
          type: 'Tween',
          name: 'heartPiece2Rotation',
          duration: 300,
          track: 40,
          target: {
            angle: -80
          },
          startAt: 500,
          sourceName: 'heartPiece2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3e940669-3be7-4cee-983f-cf95ed59be85',
          type: 'Tween',
          name: 'heartPiece2Position',
          duration: 150,
          track: 39,
          target: {
            x: -53,
            y: -29
          },
          startAt: 500,
          sourceName: 'heartPiece2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '54b1b4ce-b714-4843-8d1b-94ddedbae4dc',
          type: 'Tween',
          name: 'heartPiece4Position_copy',
          duration: 200,
          track: 30,
          target: {
            x: 110,
            y: -64
          },
          startAt: 520,
          sourceName: 'heartPiece4',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '780b2455-4850-4b2e-a55e-1f447acaaad1',
          type: 'Tween',
          name: 'heartPiecePosition_copy',
          duration: 150,
          track: 26,
          target: {
            x: -97,
            y: -133
          },
          startAt: 550,
          sourceName: 'heartPiece5',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7ce8dcd1-2d51-4b74-bcc0-291770a75b38',
          type: 'Tween',
          name: 'heartPiece3Position_copy',
          duration: 150,
          track: 35,
          target: {
            x: -114,
            y: -3
          },
          startAt: 560,
          sourceName: 'heartPiece3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c1a44e03-3a4f-4ef4-8201-50316cf0a95a',
          type: 'Setter',
          name: 'heartContainerAlpha',
          track: 47,
          target: {
            alpha: 0
          },
          startAt: 600,
          sourceName: 'heartContainer',
          disabled: false
        },
        {
          id: 'ac0fa79d-369b-4ce5-9d77-df6523a19632',
          type: 'Tween',
          name: 'heartPiece1Position_copy',
          duration: 150,
          track: 43,
          target: {
            x: 115,
            y: 29
          },
          startAt: 600,
          sourceName: 'heartPiece1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '830d5294-ef1f-4aa8-824a-24606ae7321c',
          type: 'Setter',
          name: 'heartContainerAlpha',
          track: 47,
          target: {
            alpha: 1
          },
          startAt: 611,
          sourceName: 'finalLivesText',
          disabled: false
        },
        {
          id: 'b3063b07-8eab-4d55-ad46-e47bfc2fb7c9',
          type: 'Setter',
          name: 'heartContainerPosition',
          track: 47,
          target: {
            y: -28
          },
          startAt: 620,
          sourceName: 'heartContainer',
          disabled: false
        },
        {
          id: '48ff5f6d-1e68-4441-95bf-23eb1fffcb06',
          type: 'Setter',
          name: 'heartDarkAlpha',
          track: 47,
          target: {
            alpha: 0
          },
          startAt: 630,
          sourceName: 'heartDark',
          disabled: false
        },
        {
          id: '30c48742-68db-4f88-9d46-5a952bfac6a3',
          type: 'Setter',
          name: 'heartContainer',
          track: 47,
          target: {
            scale: {
              x: 0.9,
              y: 0.9
            }
          },
          startAt: 640,
          sourceName: 'heartContainer',
          disabled: false
        },
        {
          id: 'd8ac509b-9d52-4353-b2fd-7000d3f64ea6',
          type: 'Tween',
          name: 'heartRightRotation',
          duration: 300,
          track: 22,
          target: {
            angle: 50
          },
          startAt: 650,
          sourceName: 'heartRight1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1821e42b-4a34-4184-865a-bd45460e07f1',
          type: 'Tween',
          name: 'heartRightPosition_1_1_copy_copy',
          duration: 150,
          track: 21,
          target: {
            x: 54,
            y: 123
          },
          startAt: 650,
          sourceName: 'heartRight1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '224fc733-8671-4d75-91eb-2e945a2142dc',
          type: 'Tween',
          name: 'heartLeftRotation',
          duration: 300,
          track: 18,
          target: {
            angle: -50
          },
          startAt: 650,
          sourceName: 'heartLeft1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '04abcee3-98a3-4687-908b-3f9602cc4b8d',
          type: 'Tween',
          name: 'heartLeftPosition_copy_1',
          duration: 150,
          track: 17,
          target: {
            y: 123,
            x: -54
          },
          startAt: 650,
          sourceName: 'heartLeft1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'a19e83d1-53fe-465f-9c32-2954d6c4ea1a',
          type: 'Tween',
          name: 'heartPiece2Position_copy',
          duration: 150,
          track: 39,
          target: {
            x: -122,
            y: 18
          },
          startAt: 650,
          sourceName: 'heartPiece2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a50eecfd-5e18-4f8d-8ea6-28f43b4392ab',
          type: 'Tween',
          name: 'heartPiece5Alpha',
          duration: 50,
          track: 28,
          target: {
            alpha: 0
          },
          startAt: 650,
          sourceName: 'heartPiece5',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ff7ff7c4-7f63-4366-bbfd-7f15eaff06e7',
          type: 'Tween',
          name: 'heartPiece3Alpha',
          duration: 50,
          track: 37,
          target: {
            alpha: 0
          },
          startAt: 660,
          sourceName: 'heartPiece3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '67917191-e191-403e-ac75-254ac4c4dc52',
          type: 'Tween',
          name: 'heartContainer_1_copy',
          duration: 400,
          track: 48,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 670,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '75cf5be7-1a88-43c7-97cd-835280c59025',
          type: 'Tween',
          name: 'heartContainer_1',
          duration: 400,
          track: 47,
          target: {
            alpha: 1
          },
          startAt: 670,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0a591eed-6096-4f6f-be79-cd96dd7e1f0a',
          type: 'Tween',
          name: 'heartPiece4Alpha',
          duration: 50,
          track: 32,
          target: {
            alpha: 0
          },
          startAt: 670,
          sourceName: 'heartPiece4',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2c9a0a0b-b161-474e-94a0-0089c19ab63b',
          type: 'Tween',
          name: 'heartPiece1Alpha',
          duration: 50,
          track: 45,
          target: {
            alpha: 0
          },
          startAt: 700,
          sourceName: 'heartPiece1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '95582dee-d756-4b9b-8aff-c28d11bce5a7',
          type: 'Tween',
          name: 'heartLeftScale',
          duration: 200,
          track: 20,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 750,
          sourceName: 'heartLeft1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b62cae45-fbcc-4bf2-a379-d476aa7cd4e1',
          type: 'Tween',
          name: 'heartPiece2Alpha',
          duration: 50,
          track: 41,
          target: {
            alpha: 0
          },
          startAt: 750,
          sourceName: 'heartPiece2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c2990376-709c-464d-80f9-22439ce9f89a',
          type: 'Tween',
          name: 'heartRightScale',
          duration: 200,
          track: 24,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 750,
          sourceName: 'heartRight1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '46017e3b-b6fb-48b8-afad-697f2557e0af',
          type: 'Tween',
          name: 'heartLeftPosition_copy_1_copy',
          duration: 150,
          track: 17,
          target: {
            y: 133,
            x: -54
          },
          startAt: 800,
          sourceName: 'heartLeft1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'fc1fb113-3235-4b28-8f83-744e9f4dd8d8',
          type: 'Tween',
          name: 'heartRightPosition_1_1_copy_copy_copy',
          duration: 150,
          track: 21,
          target: {
            x: 54,
            y: 133
          },
          startAt: 800,
          sourceName: 'heartRight1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5de701be-ec88-4cfa-9992-1027ad5e9617',
          type: 'Tween',
          name: 'heartRightAlpha',
          duration: 100,
          track: 23,
          target: {
            alpha: 0
          },
          startAt: 850,
          sourceName: 'heartRight1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '56f49064-5c8a-4fcd-a034-0391edb78bd6',
          type: 'Tween',
          name: 'heartLeftAlpha',
          duration: 100,
          track: 19,
          target: {
            alpha: 0
          },
          startAt: 850,
          sourceName: 'heartLeft1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c2b96392-f847-4312-8f03-4b7b9e55d3d3',
          type: 'Setter',
          name: 'brokenHeartContainerAlpha_copy',
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 1000,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'f1a5c312-d04f-46cf-b78b-3dc543feb888',
          type: 'Setter',
          name: 'heartContainerAlpha_copy',
          track: 47,
          target: {
            alpha: 1
          },
          startAt: 1110,
          sourceName: 'heartContainer',
          disabled: false
        }
      ]
    },
    {
      id: 'a3c470b8-8add-4903-b6d1-4bf1bb98eef2',
      name: 'Idle_After_Losing_Life',
      playingSpeed: 1,
      totalDuration: 4000,
      blocks: [
        {
          id: '75962be9-444d-4a62-a265-1e4c79247101',
          type: 'Setter',
          name: 'brokenHeartAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'a0b8f1ff-df3f-400c-9ad4-9490923beabb',
          type: 'Setter',
          name: 'text1Alpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'textAmount1',
          disabled: false
        },
        {
          id: 'e961fe5c-0a8c-48e4-9273-8e9170f5ad5c',
          type: 'Setter',
          name: 'text2Alpha_copy',
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'textAmount2',
          disabled: false
        },
        {
          id: '2bcaf709-9452-419f-a2b0-911044658b91',
          type: 'Tween',
          name: 'heartScale_1',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 0,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd45904d5-a8ef-4835-901f-bd4a0bc0eefc',
          type: 'Tween',
          name: 'heartWhiteAlpha',
          duration: 500,
          track: 6,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c3f1c448-b270-4df9-95d2-de8d2acf4fda',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy',
          duration: 500,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '18101269-65f8-4fbf-88fb-e9853befcd28',
          type: 'Tween',
          name: 'heartScale_1_copy',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5ee75738-70d6-453c-9641-8d7627061321',
          type: 'Tween',
          name: 'heartScale_1_copy_1',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 1000,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '33e64c9f-4bcd-4803-a630-4a08b173885d',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy_1',
          duration: 500,
          track: 6,
          target: {
            alpha: 0.2
          },
          startAt: 1000,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3ef6ea55-9bb1-4430-a097-8649d4f02a89',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy_copy',
          duration: 500,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '68eaf508-8088-48e9-be53-46402c07138e',
          type: 'Tween',
          name: 'heartScale_1_copy_copy',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '058914e8-ce6c-44ca-9e8c-330256148f96',
      name: 'Infinite_Life_Case',
      playingSpeed: 1,
      totalDuration: 4000,
      blocks: [
        {
          id: '75962be9-444d-4a62-a265-1e4c79247101',
          type: 'Setter',
          name: 'brokenHeartAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'brokenHeartContainer',
          disabled: false
        },
        {
          id: 'a0b8f1ff-df3f-400c-9ad4-9490923beabb',
          type: 'Setter',
          name: 'text1Alpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'textAmount1',
          disabled: false
        },
        {
          id: '6036d860-2d1c-4532-b719-5e690fc4c692',
          type: 'Setter',
          name: 'infinityAlpha',
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'infinity',
          disabled: false
        },
        {
          id: '16c92a79-1903-4ade-a563-e8c94fafd0f1',
          type: 'Setter',
          name: 'setFinalLivesAlpha',
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'finalLivesText',
          disabled: false
        },
        {
          id: '0d7e408f-99b5-4c25-ac2b-623c6faca5c0',
          type: 'Setter',
          name: 'setCurrentLivesAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'currentLivesText',
          disabled: false
        },
        {
          id: '55e342f3-6caf-4c51-85f1-78f8c4e32386',
          type: 'Setter',
          name: 'setTextDescriptionAlpha_0',
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'textDescription',
          disabled: false
        },
        {
          id: '40099ba2-054d-4bf6-a589-68700f70d32b',
          type: 'Setter',
          name: 'setBackgroundNoTitleAlpha_0',
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'beigeBackgroundNoTitle',
          disabled: false
        },
        {
          id: '2bcaf709-9452-419f-a2b0-911044658b91',
          type: 'Tween',
          name: 'heartScale_1',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 0,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd45904d5-a8ef-4835-901f-bd4a0bc0eefc',
          type: 'Tween',
          name: 'heartWhiteAlpha',
          duration: 500,
          track: 6,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c3f1c448-b270-4df9-95d2-de8d2acf4fda',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy',
          duration: 500,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '18101269-65f8-4fbf-88fb-e9853befcd28',
          type: 'Tween',
          name: 'heartScale_1_copy',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5ee75738-70d6-453c-9641-8d7627061321',
          type: 'Tween',
          name: 'heartScale_1_copy_1',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 1000,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '33e64c9f-4bcd-4803-a630-4a08b173885d',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy_1',
          duration: 500,
          track: 6,
          target: {
            alpha: 0.2
          },
          startAt: 1000,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3ef6ea55-9bb1-4430-a097-8649d4f02a89',
          type: 'Tween',
          name: 'heartWhiteAlpha_copy_copy',
          duration: 500,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '68eaf508-8088-48e9-be53-46402c07138e',
          type: 'Tween',
          name: 'heartScale_1_copy_copy',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class YouLostALifeLayout {
  static raw = raw;
  root!: Container;
  beigeBackground!: NineSlicePlane;
  beigeBackgroundLarge!: NineSlicePlane;
  beigeBackgroundNoTitle!: NineSlicePlane;
  rays!: Sprite & { data: typeof raw['list'][4]['data'] };
  textDescription!: Text;
  scaleContainer!: Container;
  heartContainer!: Container;
  brokenHeartContainer!: Container;
  heartPiece1!: Sprite;
  heartPiece2!: Sprite;
  heartPiece3!: Sprite;
  heartPiece4!: Sprite;
  heartPiece5!: Sprite;
  heartShadow!: Sprite;
  heart!: Sprite;
  heartWhite!: Sprite;
  heartDark!: Sprite;
  infinity!: Sprite;
  currentLivesText!: Text;
  finalLivesText!: Text;
  heartLeft1!: Sprite;
  heartRight1!: Sprite;
  crack!: Sprite;
  heartLeftCrack!: Sprite;
  heartRightCrack!: Sprite;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][4]['data'] })[];
  StateName!: 'watchAd';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Lose_Life {
  Layout: {
    brokenHeartContainer: object;
    heartDark: object;
    m: object;
    finalLivesText: object;
    heartContainer: object;
    root: object;
    currentLivesText: object;
    crack: object;
    heartPiece5: object;
    heartLeft1: object;
    heartRight1: object;
    heartPiece3: object;
    heartPiece4: object;
    heartPiece1: object;
    heartPiece2: object;
  };

  BlockTypeByName: {
    brokenHeartAlpha: object;
    heartDarkAlpha: object;
    New_setter: object;
    textAmount2Alpha: object;
    heartAlpha_copy: object;
    SFX_Soft_Fail: object;
    textAmount2Alpha: object;
    textAmount1Alpha: object;
    heartScale: object;
    heartPosition: object;
    text1Scale: object;
    text1Scale_copy: object;
    heartScale_copy: object;
    heartPosition_copy: object;
    heartDarkAlpha_1: object;
    brokenHeartContainerAlpha: object;
    crackAlpha_copy: object;
    borkenHeartContainerPosition: object;
    borkenHeartContainerScale: object;
    heartAlpha: object;
    heartPiece5Scale: object;
    heartPiece5Rotation: object;
    heartPiecePosition: object;
    heartLeftPosition: object;
    heartRightPosition_1_1: object;
    heartPiece3Scale: object;
    heartPiece3Rotation: object;
    heartPiece3Position: object;
    borkenHeartContainerPosition: object;
    borkenHeartContainerScale: object;
    heartPiece4Scale: object;
    heartPiece4Rotation: object;
    heartPiece4Position: object;
    crackAlpha: object;
    heartPiece1Scale: object;
    heartPiece1Rotation: object;
    heartPiece1Position: object;
    heartRightPosition_1_1_copy: object;
    heartLeftPosition_copy: object;
    heartPiece2Scale: object;
    heartPiece2Rotation: object;
    heartPiece2Position: object;
    heartPiece4Position_copy: object;
    heartPiecePosition_copy: object;
    heartPiece3Position_copy: object;
    heartContainerAlpha: object;
    heartPiece1Position_copy: object;
    heartContainerAlpha: object;
    heartContainerPosition: object;
    heartDarkAlpha: object;
    heartContainer: object;
    heartRightRotation: object;
    heartRightPosition_1_1_copy_copy: object;
    heartLeftRotation: object;
    heartLeftPosition_copy_1: object;
    heartPiece2Position_copy: object;
    heartPiece5Alpha: object;
    heartPiece3Alpha: object;
    heartContainer_1_copy: object;
    heartContainer_1: object;
    heartPiece4Alpha: object;
    heartPiece1Alpha: object;
    heartLeftScale: object;
    heartPiece2Alpha: object;
    heartRightScale: object;
    heartLeftPosition_copy_1_copy: object;
    heartRightPosition_1_1_copy_copy_copy: object;
    heartRightAlpha: object;
    heartLeftAlpha: object;
    brokenHeartContainerAlpha_copy: object;
    heartContainerAlpha_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle_After_Losing_Life {
  Layout: {
    brokenHeartContainer: object;
    textAmount1: object;
    textAmount2: object;
    heartContainer: object;
    heartWhite: object;
  };

  BlockTypeByName: {
    brokenHeartAlpha: object;
    text1Alpha: object;
    text2Alpha_copy: object;
    heartScale_1: object;
    heartWhiteAlpha: object;
    heartWhiteAlpha_copy: object;
    heartScale_1_copy: object;
    heartScale_1_copy_1: object;
    heartWhiteAlpha_copy_1: object;
    heartWhiteAlpha_copy_copy: object;
    heartScale_1_copy_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Infinite_Life_Case {
  Layout: {
    brokenHeartContainer: object;
    textAmount1: object;
    infinity: object;
    finalLivesText: object;
    currentLivesText: object;
    textDescription: object;
    beigeBackgroundNoTitle: object;
    heartContainer: object;
    heartWhite: object;
  };

  BlockTypeByName: {
    brokenHeartAlpha: object;
    text1Alpha: object;
    infinityAlpha: object;
    setFinalLivesAlpha: object;
    setCurrentLivesAlpha: object;
    setTextDescriptionAlpha_0: object;
    setBackgroundNoTitleAlpha_0: object;
    heartScale_1: object;
    heartWhiteAlpha: object;
    heartWhiteAlpha_copy: object;
    heartScale_1_copy: object;
    heartScale_1_copy_1: object;
    heartWhiteAlpha_copy_1: object;
    heartWhiteAlpha_copy_copy: object;
    heartScale_1_copy_copy: object;
  };

  flowData = raw.animations[2];
}
